import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [ "templateLink", "fileInput" ]

  connect() {
    // console.log("Hello, Import Roster Controller here!", this.element);
  }

  updateFileType(event) {
    this.fileInputTarget.value = '';
    this.fileInputTarget.files = new DataTransfer().files;
    this.fileInputTarget.dispatchEvent(new Event('change', { bubbles: true }));

    if (event.target.value === 'csv') {
      this.templateLinkTarget.classList.remove('d-none');
      this.templateLinkTarget.classList.add('d-block');

      this.fileInputTarget.accept = '.csv';
    } else {
      this.templateLinkTarget.classList.remove('d-block');
      this.templateLinkTarget.classList.add('d-none');

      this.fileInputTarget.accept = '.pdf';
    }
  }
}
